import React, { Children, cloneElement, useState } from "react"
import { AppBar, Box, Button } from "@material-ui/core"
import useStyles from "./styles"

const ToggleBar = ({ children, activeTab, setActiveTab }) => {
  const classes = useStyles()

  const toggle = index => {
    setActiveTab(index)
  }
  const active = { fontWeight: 700 }
  return (
    <AppBar elevation={0} position="relative" color="primary">
      <Box className={classes.root} display="flex" alignItems="center">
        {Children.map(children, (child, index) => {
          /* eslint-disable */
          return typeof child.type === "string"
            ? child
            : cloneElement(child, {
              toggle,
              index,
              style: activeTab === index ? active : {}
            })
        })}
      </Box>
    </AppBar>
  )
}

function ToggleBarButton({ children, toggle, index, style, ...props }) {
  return (
    <Button variant="text" onClick={() => toggle(index)} style={style} {...props}>
      {children}
    </Button>
  )
}

export { ToggleBar, ToggleBarButton }



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/ToggleBar/index.jsx